import api from "@/service/api";

const state = () => ({
    methods: null,
})

const mutations = {
    setMethods(state, value) {
        state.methods = value;
    },
}

const actions = {
    refresh({ commit }) {
        return api
            .post("/paymentMethod/index")
            .then((response) => {
                commit("setMethods", response.data.paymentMethods);
            });
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
}
